import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    addProjectName: string;
    cancel: string;
    create: string;
    defaultProjectName: (name: string) => string | React.ReactNode;
    duplicateProject: string;
    editAvatar: string;
    includeAssets: string;
    name: string;
    changesDiscarded: string;
    createProject: string;
    subtitle: string;
    done: string;
    tooLong: (number: number) => string | React.ReactNode;
    tryAgain: string;
    overAssetLimit: string;
    dialogCloseLabel: string;
};
export type Deps = {
    INCLUDE_ASSETS_LIMIT: any;
};
export default {
    DEFINE(_messages: Text, { INCLUDE_ASSETS_LIMIT }: Deps): void {
        return Object.defineProperties(this, {
            /** Placeholder text for project name input */
            addProjectName: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "DuplicateProjectModal.addProjectName?c=37t0j07eksp2t", defaultMessage: "Add project name" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Secondary action label to cancel duplication */
            cancel: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "DuplicateProjectModal.cancel?c=2ojhd8rzicmo0", defaultMessage: "Cancel" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Primary action label to create the duplicate */
            create: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "DuplicateProjectModal.create?c=346wnqj4f9ban", defaultMessage: "Duplicate Project" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Default name for a duplicated project */
            defaultProjectName: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (name: string) => __intl__.intl().formatMessage({ id: "DuplicateProjectModal.defaultProjectName?c=zvpfgw3qzfn3", defaultMessage: "{name} copy" }, { name: name }));
                },
                enumerable: true,
                configurable: true
            },
            /** Dialog title for duplicating a project */
            duplicateProject: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "DuplicateProjectModal.duplicateProject?c=346wnqj4f9ban", defaultMessage: "Duplicate Project" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Label for the avatar editor action */
            editAvatar: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "DuplicateProjectModal.editAvatar?c=m32wpmcnpvan", defaultMessage: "Edit project avatar" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Toggle label for including assets in the duplicate */
            includeAssets: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "DuplicateProjectModal.includeAssets?c=3v2rve4zecby2", defaultMessage: "Include assets" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Field label for project name */
            name: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "DuplicateProjectModal.name?c=225ge594d9ejj", defaultMessage: "Name" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Toast or inline message for discarded changes */
            changesDiscarded: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "DuplicateProjectModal.changesDiscarded?c=37ekoedzz41ej", defaultMessage: "Changes have been discarded" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Dialog title for creating a new project */
            createProject: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "DuplicateProjectModal.createProject?c=1oiqzouofct2u", defaultMessage: "Create New Project" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Subtitle describing what is excluded from duplication */
            subtitle: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "DuplicateProjectModal.subtitle?c=3a5amp9oqdgkb", defaultMessage: "Does not include users, comments, or Shares" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Button label to finish the dialog */
            done: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "DuplicateProjectModal.done?c=1qtcbgq8drjyi", defaultMessage: "Done" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Validation message for name length limits */
            tooLong: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (number: number) => __intl__.intl().formatMessage({ id: "DuplicateProjectModal.tooLong?c=10k0idl5h8hts", defaultMessage: "You\u2019ve exceeded the {number} character limit for this name" }, { number: number }));
                },
                enumerable: true,
                configurable: true
            },
            /** Generic error message for failed actions */
            tryAgain: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "DuplicateProjectModal.tryAgain?c=2j9rawb98q40g", defaultMessage: "Something went wrong, please try again." }));
                },
                enumerable: true,
                configurable: true
            },
            /** Warning when project exceeds asset duplication limit */
            overAssetLimit: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "DuplicateProjectModal.overAssetLimit?c=21cs1jr2keo5p", defaultMessage: "Cannot duplicate assets in projects with over {INCLUDE_ASSETS_LIMIT} assets" }, { INCLUDE_ASSETS_LIMIT: INCLUDE_ASSETS_LIMIT }));
                },
                enumerable: true,
                configurable: true
            },
            /** Accessible label for the dialog close button */
            dialogCloseLabel: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "DuplicateProjectModal.dialogCloseLabel?c=2g2kiprif3vje", defaultMessage: "Close Dialog" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps: Deps): void;
};
